/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { FlowStatus } from "../redux/constants";
import defaultTheme from "../theme/default";
import ScreenBuilder from "../screens/screen-builder";
import {
  masks as themeMasks,
  unmasks as themeUnmasks
} from "../theme/default/masks";
import { MessagingLayer } from "../context/messaging-layer";
import { ToastNotifications } from "../context/toast-notifications";
import { RootContext } from "../context/root-ref";
import { constants } from "../resource/constants";
import { setCssVariable } from "../utils/styles";

export class TdFlowApp extends Component {
  constructor(props) {
    super(props);
    this.rootRef = React.createRef();
    this.containerRef = React.createRef();
    this.state = { storePrepared: false };
  }

  async componentDidMount() {
    const {
      initialRequest,
      getContainerSize,
      initializeTdFlow,
      isPageReloaded,
      appConfiguration: { isUnifiedRegistration }
    } = this.props;
    await initializeTdFlow({
      initialRequest,
      isPageReloaded,
      isUnifiedRegistration
    });
    this.setState({ storePrepared: true });

    setCssVariable(this.rootRef.current, "--vh", `${window.innerHeight}px`);
    window.addEventListener("resize", () => {
      setCssVariable(this.rootRef.current, "--vh", `${window.innerHeight}px`);
      this.sendContainerSize(getContainerSize);
    });
  }

  componentDidUpdate() {
    const { getContainerSize } = this.props;
    this.sendContainerSize(getContainerSize);
  }

  componentWillUnmount() {
    const abortController = window[constants.abortControllerKey];
    if (abortController) {
      abortController.abort();
    }
  }

  setRedesignClassNames(screen) {
    let classNames = "";
    const {
      appConfiguration: { isEnhancedRedesign, isPulse } = {},
      formState
    } = this.props;

    // this should be refactored when mapi changes are released.
    // after the mapi release pulse styles should depend only on screen.pulse flag
    const generalMedicalVisit = "General Medical";
    const isGenMed = formState?.health_category === generalMedicalVisit;

    if (screen?.pulse || (isGenMed && isPulse)) {
      classNames += "pulse-rav ";
    }

    if (isEnhancedRedesign) {
      classNames += "enhanced-redesign";
    }

    return classNames;
  }

  sendContainerSize(getContainerSize) {
    // check if getContainerSize handler was paased into WebSDK
    // send container size object to wrapper application
    if (getContainerSize) {
      getContainerSize(this.containerRef.current.getBoundingClientRect());
    }
  }

  render() {
    // Since all bundle IDs come in form of 'com.xxxx', we just drop the 'com.' part and use what's left as a classname.
    // This way 'com.td-core' becomes 'td-core' and 'com.healthiestyou' becomes 'healthiestyou'.
    // Temporarily 'com.teladoc.members.canada' bundle ID is added,
    // in order to differentiate Teladoc USA from Tealdoc Canada in mobile_api.
    // We need this in order to be able to enable the translations in Canada.
    // So after dropping the 'com.' part we replace all dots with dashes.
    // This way 'com.teladoc.members.canada' becomes 'teladoc-members-canada'.
    //
    // TODO: Consider implementing "brand" experience in websdk which is compliant with TeladocI18n gem.
    // https://teladoc.atlassian.net/browse/EU-1175

    const {
      data,
      screenIndex,
      screenInitialized,
      history,
      lastNavAction,
      initializeScreen,
      initializePrevScreen,
      fieldChanged,
      assesmentChanged,
      assesmentsState,
      fieldConfigurations,
      nextScreen,
      prevScreen,
      exitScreen,
      fetchFlow,
      saveMedicalHistory,
      pharmacies,
      searchPharmacies,
      searchRetailPharmacies,
      capsuleDeliverableCheck,
      capsuleDelivery,
      providerFilters,
      setFilters,
      resetFilters,
      pickPharmacyOnMap,
      startOver,
      initialRequest,
      formState: values,
      screenParams,
      flowStatus,
      validation,
      toasts,
      setValidation,
      resetValidation,
      addToast,
      removeToast,
      uploadPhoto,
      uploadPhotoGeneric,
      uploadPhotoMHD,
      uploadPhotoEMO,
      uploadPhotoMHN,
      uploadPhotoVideoRoom,
      uploadPhotoEDIS,
      providerDetailData,
      setDetailProviderData,
      resetDetailProviderData,
      providerDetailFieldsData,
      careTeamProviderDetailFieldsData,
      setDetailProviderFieldsData,
      setDetailCareTeamProviderFieldsData,
      dermTreatmentData,
      setTreatmentData,
      deleteTreatmentData,
      updateTreatmentData,
      resetTreatmentData,
      treatmentToEditData,
      setTreatmentToEdit,
      resetTreatmentToEdit,
      consultStatus,
      updateConsultState,
      screensHistoryFlow,
      updateScreensHistoryFlow,
      updateScreenHistoryAction,
      onExit = exitScreen,
      fieldValidation,
      setFieldValidation,
      resetFieldValidation,
      resetFieldValidationAll,
      dependentStored,
      dependentStoredSuccess,
      resetDependent,
      careRecipientStored,
      careRecipientStoredSuccess,
      resetCareRecipient,
      getCurrentLocation,
      trackingEvents,
      addTrackingEvent,
      sendTrackingEvents,
      formGroupErrors,
      setFormGroupErrors,
      resetReduxStore,
      setFlowStatusLoading,
      showHud,
      setShowHud,
      resetShowHud,
      initializeDialog,
      clearDialogFlow,
      dialogInitialized,
      settings,
      resetActionField,
      isGlobalDialogShown,
      dateTimeSelection,
      fetchAvailableTimes,
      setSelectedDate,
      setSelectedTime,
      clearDateTimeSelection,
      callToActionButton,
      pageNumber,
      setPageNumber,
      setSelectedListItem,
      selectedListItem,
      addCallToActionButtonIsLoading,
      removeCallToActionButtonIsLoading,
      setFormErrorsFromBack,
      piiCollectedSuccess,
      isPiiCollected,
      appConfiguration: {
        getModalPosition,
        locale,
        isEnhancedRedesign = false,
        properLink = false,
        isUnifiedRegistration = false,
        brandCountryCode = constants.DEFAULT_COUNTRY_CODE,
        isOneApp = false
      },
      setFormState,
      deleteFromFormState,
      fetchPostFile,
      disableAttachmentsInNewTab = false,
      isItemSelected,
      onItemSelected,
      resetItemSelected,
      resetFormFields,
      resetFieldsValidation,
      returnToInbox
    } = this.props;
    const screen = data && data.screens ? data.screens[screenIndex] : undefined;
    if (!screen && this.props.flowStatus !== FlowStatus.LOADING) {
      return "Invalid screen!";
    }

    const screenValidation = {
      fields: [],
      validationMessage: ""
    };
    const components = { ...defaultTheme };
    let { masks, unmasks, fieldAttributes } = fieldConfigurations || {};
    const { validators } = fieldConfigurations || {};
    masks = { ...masks, ...themeMasks };
    unmasks = { ...unmasks, ...themeUnmasks };
    fieldAttributes = fieldAttributes || {};

    const runFieldActions = {};

    const appData = {
      data,
      fieldAttributes,
      masks,
      unmasks,
      validators,
      screenIndex,
      history,
      values,
      screenParams,
      flowStatus,
      validation,
      toasts,
      setValidation,
      resetValidation,
      addToast,
      removeToast,
      handleChange: fieldChanged,
      assesmentChanged,
      assesmentsState,
      initializeScreen,
      initializePrevScreen,
      nextScreen: nextScreen.bind(undefined, onExit),
      prevScreen,
      fetchFlow,
      saveMedicalHistory,
      screenInitialized,
      lastNavAction,
      screenValidation,
      providerFilters,
      setFilters,
      resetFilters,
      pharmacies,
      searchPharmacies,
      searchRetailPharmacies,
      capsuleDeliverableCheck,
      capsuleDelivery,
      pickPharmacyOnMap,
      initialRequest,
      startOver,
      uploadPhoto,
      uploadPhotoGeneric,
      uploadPhotoMHD,
      uploadPhotoEMO,
      uploadPhotoMHN,
      uploadPhotoVideoRoom,
      uploadPhotoEDIS,
      providerDetailData,
      setDetailProviderData,
      resetDetailProviderData,
      providerDetailFieldsData,
      careTeamProviderDetailFieldsData,
      setDetailProviderFieldsData,
      setDetailCareTeamProviderFieldsData,
      dermTreatmentData,
      setTreatmentData,
      deleteTreatmentData,
      updateTreatmentData,
      resetTreatmentData,
      treatmentToEditData,
      setTreatmentToEdit,
      resetTreatmentToEdit,
      consultStatus,
      updateConsultState,
      onExit,
      screensHistoryFlow,
      updateScreensHistoryFlow,
      updateScreenHistoryAction,
      fieldValidation,
      setFieldValidation,
      resetFieldValidation,
      resetFieldValidationAll,
      dependentStored,
      dependentStoredSuccess,
      resetDependent,
      careRecipientStored,
      careRecipientStoredSuccess,
      resetCareRecipient,
      getCurrentLocation,
      trackingEvents,
      addTrackingEvent,
      sendTrackingEvents,
      resetReduxStore,
      dateTimeSelection,
      fetchAvailableTimes,
      setSelectedDate,
      setSelectedTime,
      clearDateTimeSelection,
      runFieldActions,
      callToActionButton,
      removeCallToActionButtonIsLoading,
      addCallToActionButtonIsLoading,
      isPulse: screen?.pulse,
      setFormState,
      deleteFromFormState,
      formGroupErrors,
      setFormGroupErrors,
      setFlowStatusLoading,
      showHud,
      setShowHud,
      resetShowHud,
      initializeDialog,
      clearDialogFlow,
      dialogInitialized,
      settings,
      resetActionField,
      isGlobalDialogShown,
      isEnhancedRedesign,
      properLink,
      isUnifiedRegistration,
      brandCountryCode,
      setFormErrorsFromBack,
      piiCollectedSuccess,
      isPiiCollected,
      pageNumber,
      setPageNumber,
      setSelectedListItem,
      selectedListItem,
      fetchPostFile,
      disableAttachmentsInNewTab,
      isItemSelected,
      onItemSelected,
      resetItemSelected,
      resetFormFields,
      resetFieldsValidation,
      locale,
      returnToInbox,
      isOneApp
    };

    const screenBuilder = (
      <ScreenBuilder
        appData={appData}
        components={components}
        screen={screen}
        isRoot
        TdFlowApp={this}
      />
    );

    const { one_moment_please = "" } = settings?.translations || {};

    const defaultLoader = (
      <defaultTheme.Loader text={one_moment_please} isHidden={properLink} />
    );

    const screenBuilderWithLoaderInDialog = (
      <>
        <defaultTheme.LoaderInDialog text={one_moment_please} textDelay={0} />
        {screenBuilder}
      </>
    );

    return (
      <MessagingLayer
        appData={appData}
        components={components}
        globalDialogConfig={screenParams.dialogConfig}
        formRef={this.rootRef}
        getModalPosition={getModalPosition}
      >
        <ToastNotifications components={components}>
          <RootContext.Provider value={this.rootRef}>
            <div className='root-web-sdk' ref={this.containerRef}>
              <form
                className={this.setRedesignClassNames(screen)}
                id='containerForm'
                ref={this.rootRef}
              >
                {flowStatus === FlowStatus.LOADING && showHud
                  ? screenBuilderWithLoaderInDialog
                  : flowStatus === FlowStatus.LOADING
                  ? defaultLoader
                  : screenBuilder}
              </form>
            </div>
          </RootContext.Provider>
        </ToastNotifications>
      </MessagingLayer>
    );
  }
}

const DateTimeSelectionShape = PropTypes.shape({
  selectedDate: PropTypes.string.isRequired,
  selectedTime: PropTypes.string.isRequired,
  error: PropTypes.string.isRequired,
  availableTimes: PropTypes.arrayOf(PropTypes.string).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool.isRequired
});

const CallToActionButtonShape = PropTypes.shape({
  isLoading: PropTypes.bool.isRequired,
  buttonName: PropTypes.string
});

export const TdFlowAppRef = null;

TdFlowApp.propTypes = {
  screenIndex: PropTypes.number.isRequired,
  history: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      index: PropTypes.number.isRequired
    }).isRequired
  ).isRequired,
  lastNavAction: PropTypes.string.isRequired,
  formState: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.any]))
    .isRequired,
  fetchFlow: PropTypes.func.isRequired,
  saveMedicalHistory: PropTypes.func.isRequired,
  uploadPhoto: PropTypes.func.isRequired,
  uploadPhotoGeneric: PropTypes.func.isRequired,
  uploadPhotoMHD: PropTypes.func.isRequired,
  uploadPhotoEMO: PropTypes.func.isRequired,
  setFlowStatusLoading: PropTypes.func.isRequired,
  uploadPhotoMHN: PropTypes.func.isRequired,
  uploadPhotoVideoRoom: PropTypes.func.isRequired,
  uploadPhotoEDIS: PropTypes.func.isRequired,
  fieldChanged: PropTypes.func.isRequired,
  initializeScreen: PropTypes.func.isRequired,
  initializePrevScreen: PropTypes.func.isRequired,
  nextScreen: PropTypes.func.isRequired,
  prevScreen: PropTypes.func.isRequired,
  searchPharmacies: PropTypes.func.isRequired,
  searchRetailPharmacies: PropTypes.func.isRequired,
  capsuleDeliverableCheck: PropTypes.func,
  capsuleDelivery: PropTypes.func,
  providerFilters: PropTypes.oneOfType([PropTypes.object]),
  pickPharmacyOnMap: PropTypes.func.isRequired,
  setFilters: PropTypes.func,
  startOver: PropTypes.func.isRequired,
  resetFilters: PropTypes.func,
  setDetailProviderData: PropTypes.func.isRequired,
  resetDetailProviderData: PropTypes.func.isRequired,
  setDetailProviderFieldsData: PropTypes.func.isRequired,
  setDetailCareTeamProviderFieldsData: PropTypes.func.isRequired,
  setFormState: PropTypes.func.isRequired,
  deleteFromFormState: PropTypes.func.isRequired,
  getContainerSize: PropTypes.func,
  setTreatmentData: PropTypes.func.isRequired,
  deleteTreatmentData: PropTypes.func.isRequired,
  updateTreatmentData: PropTypes.func.isRequired,
  resetTreatmentData: PropTypes.func.isRequired,
  setTreatmentToEdit: PropTypes.func.isRequired,
  resetTreatmentToEdit: PropTypes.func.isRequired,
  setValidation: PropTypes.func.isRequired,
  resetValidation: PropTypes.func.isRequired,
  addToast: PropTypes.func.isRequired,
  removeToast: PropTypes.func.isRequired,
  updateConsultState: PropTypes.func.isRequired,
  setFieldValidation: PropTypes.func.isRequired,
  resetFieldValidation: PropTypes.func.isRequired,
  dependentStoredSuccess: PropTypes.func.isRequired,
  resetDependent: PropTypes.func.isRequired,
  careRecipientStoredSuccess: PropTypes.func.isRequired,
  resetCareRecipient: PropTypes.func.isRequired,
  getCurrentLocation: PropTypes.func.isRequired,
  addTrackingEvent: PropTypes.func.isRequired,
  setFormGroupErrors: PropTypes.func.isRequired,
  resetFieldValidationAll: PropTypes.func.isRequired,
  showHud: PropTypes.bool.isRequired,
  setShowHud: PropTypes.func.isRequired,
  resetShowHud: PropTypes.func.isRequired,
  assesmentChanged: PropTypes.func.isRequired,
  updateScreensHistoryFlow: PropTypes.func.isRequired,
  updateScreenHistoryAction: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired,
  resetFormState: PropTypes.func.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  setSelectedListItem: PropTypes.func.isRequired,
  pharmacies: PropTypes.shape({
    all: PropTypes.arrayOf(PropTypes.object).isRequired,
    selected: PropTypes.objectOf(PropTypes.object)
  }).isRequired,
  screensHistoryFlow: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any))
    .isRequired,
  screenParams: PropTypes.objectOf(PropTypes.any).isRequired,
  providerDetailData: PropTypes.objectOf(PropTypes.object).isRequired,
  providerDetailFieldsData: PropTypes.arrayOf(PropTypes.object),
  careTeamProviderDetailFieldsData: PropTypes.arrayOf(PropTypes.object),
  settings: PropTypes.objectOf(PropTypes.object),
  dermTreatmentData: PropTypes.objectOf(PropTypes.object).isRequired,
  treatmentToEditData: PropTypes.objectOf(PropTypes.object).isRequired,
  consultStatus: PropTypes.objectOf(PropTypes.object).isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  fieldConfigurations: PropTypes.objectOf(PropTypes.object),
  flowStatus: PropTypes.string,
  assesmentsState: PropTypes.objectOf(PropTypes.any),
  validation: PropTypes.objectOf(PropTypes.any),
  toasts: PropTypes.arrayOf(PropTypes.object),
  initialRequest: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ),
  screenInitialized: PropTypes.bool,
  fieldValidation: PropTypes.objectOf(PropTypes.object),
  dependentStored: PropTypes.bool,
  careRecipientStored: PropTypes.bool,
  trackingEvents: PropTypes.arrayOf(PropTypes.object),
  sendTrackingEvents: PropTypes.func.isRequired,
  appConfiguration: PropTypes.objectOf(PropTypes.any),
  initializeDialog: PropTypes.func.isRequired,
  clearDialogFlow: PropTypes.func.isRequired,
  dialogInitialized: PropTypes.bool.isRequired,
  resetReduxStore: PropTypes.func.isRequired,
  initializeTdFlow: PropTypes.func.isRequired,
  resetActionField: PropTypes.func.isRequired,
  isPageReloaded: PropTypes.bool,
  dateTimeSelection: DateTimeSelectionShape.isRequired,
  fetchAvailableTimes: PropTypes.func.isRequired,
  setSelectedDate: PropTypes.func.isRequired,
  setSelectedTime: PropTypes.func.isRequired,
  clearDateTimeSelection: PropTypes.func.isRequired,
  callToActionButton: CallToActionButtonShape.isRequired,
  addCallToActionButtonIsLoading: PropTypes.func.isRequired,
  removeCallToActionButtonIsLoading: PropTypes.func.isRequired,
  formGroupErrors: PropTypes.arrayOf(Object),
  isGlobalDialogShown: PropTypes.bool,
  setFormErrorsFromBack: PropTypes.func.isRequired,
  piiCollectedSuccess: PropTypes.func.isRequired,
  isPiiCollected: PropTypes.bool,
  fetchPostFile: PropTypes.func.isRequired,
  disableAttachmentsInNewTab: PropTypes.bool,
  pageNumber: PropTypes.number,
  selectedListItem: PropTypes.objectOf(PropTypes.object),
  onItemSelected: PropTypes.func.isRequired,
  resetItemSelected: PropTypes.func.isRequired,
  isItemSelected: PropTypes.bool,
  resetFormFields: PropTypes.func.isRequired,
  resetFieldsValidation: PropTypes.func.isRequired,
  returnToInbox: PropTypes.func.isRequired
};
